import { apiWrapper } from "@/services/api";
import store from "@/store/index";
import mfittService from "@/services/MFITT";

// 空席照会時刻指定API(vacantSeatDisplayNum=> 通常:0, 次の列車:1, 前の列車:2)
export const getVacancyInquiry = async (
  vacantSeatDisplayNum = 0,
  trainIndexNum = "",
  ticketID = ""
) => {
  let response;
  try {
    const inputtedInfoOnBooking = store.getters["MFITT/inputtedInfoOnBooking"];
    let url = `/mfitt/vacancy_inquiry?boarding_date=${mfittService.convertDateFormatForApi(
      inputtedInfoOnBooking.boarding_date
    )}&search_division=${
      inputtedInfoOnBooking.search_division
    }&time=${mfittService.convertTimeFormatForApi(
      inputtedInfoOnBooking.time
    )}&first_from_station_id=${
      inputtedInfoOnBooking.from_station.id
    }&first_to_station_id=${
      inputtedInfoOnBooking.to_station.id
    }&vacant_seat_display=${vacantSeatDisplayNum}&train_index_number=${trainIndexNum}&include_exclusive_cars=true`;

    // 発着照会追加がある場合(from/to どちらか片方のみ指定可能)
    if (inputtedInfoOnBooking.second_from_station != null) {
      url += `&second_from_station_id=${inputtedInfoOnBooking.second_from_station.id}`;
    } else if (inputtedInfoOnBooking.second_to_station != null) {
      url += `&second_to_station_id=${inputtedInfoOnBooking.second_to_station.id}`;
    }

    const selectedCoupon = store.getters["MFITT/selectedCoupon"];
    if (selectedCoupon) {
      url += `&coupon_id=${selectedCoupon.id}`;
    }

    //列車変更の場合はチケットIDをパラメータに付与する。
    if (ticketID) {
      url += `&changing_limited_express_ticket_id=${ticketID}`;
    }

    response = await apiWrapper("GET", url);
    console.log("getVacancyInquiry response.data :>> ", response.data);
    store.commit("MFITT/setVacancyInquiry", response.data);
  } catch (err) {
    console.log('ERROR"" getVacancyInquiry():', err);
    throw err;
  }
  return response.data;
};
